import React from "react";
import styled from "styled-components";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import locale from "antd/es/date-picker/locale/zh_TW";
import { useDispatch, useSelector } from "react-redux";

import { setVipGiftListFilter, VipRuleState } from "@redux/vipPromotionSlice";

const WrapperForm = styled(Form)`
  padding: 20px;
`;
const CustomRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;

const Filter = () => {
  const dispatch = useDispatch();
  const { vipGiftListFilter } = useSelector(VipRuleState);

  const [form] = Form.useForm();

  const onSubmit = (values: any) => {
    const { salesPlanName, useDate, isActive } = values;
    const payload = {
      ...vipGiftListFilter,
      salesPlanName,
      useStartAt: useDate && useDate[0]?.format("YYYY-MM-DD"),
      useEndAt: useDate && useDate[1]?.format("YYYY-MM-DD"),
      isActive,
    };

    dispatch(setVipGiftListFilter(payload));
  };

  const clearFilter = () => {
    form.resetFields();
    const payload = {
      ...vipGiftListFilter,
      salesPlanName: undefined,
      useStartAt: undefined,
      useEndAt: undefined,
      isActive: undefined,
    };
    dispatch(setVipGiftListFilter(payload));
  };

  return (
    <WrapperForm
      labelCol={{ span: 6 }}
      colon={false}
      labelAlign="left"
      form={form}
      initialValues={{}}
      onFinish={onSubmit}
    >
      <Row gutter={40}>
        <Col span={12}>
          <Form.Item label="方案名稱" name="salesPlanName">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="使用時間" name="useDate">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={40}>
        <Col span={12}>
          <Form.Item label="狀態" name="isActive">
            <Select placeholder="請選擇">
              <Select.Option value>上架</Select.Option>
              <Select.Option value={false}>下架</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={30} justify="end">
        <Col>
          <Row>
            <CustomButton onClick={clearFilter}>清除篩選條件</CustomButton>
            <Button type="primary" htmlType="submit">
              套用
            </Button>
          </Row>
        </Col>
      </Row>
    </WrapperForm>
  );
};

export default Filter;
